import React from "react";
import { useNavigate } from "react-router-dom";

export default function AiDevelopmentHero() {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12">
          <div className="ai-Video-container">
            <video
              width="100%"
              controls={false}
              loop
              autoPlay
              muted
              playsInline
              className="bg-video"
            >
              <source
                src="/images/AIDevelopmentPageVideo.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <div className="overlay-text px-6">
              <h1>AI Development Services</h1>
              <p className="mt-4 mt-md-3">
                Is your business ready to transform its operations with AI? We
                provide full stack AI development services to help you achieve
                your strategic goals with innovative and high performing AI
                solutions.
              </p>
              <p>
                Our team of skilled AI developers have advanced machine learning
                capabilities to deliver AI services customized for your specific
                needs. As a reputed AI development company, we specialize in
                areas like computer vision, natural language processing, and
                predictive analytics.We'll work with you to create custom AI
                solutions that streamline your processes, automate tasks, and
                provide actionable insights for smart decision making.
              </p>
              <button
                class="ai-TalkBtn mt-2"
                onClick={() => {
                  navigate("/contact-us");
                }}
              >
                <span class="ai-text-wrapper">
                  <span class="ai-text ai-text-default">
                    Let's Talk{" "}
                    <img
                      className="ms-4"
                      src="/images/AboutUs/icons/arrow-right-hover.svg"
                      alt=""
                    />
                  </span>
                  <span class="ai-text ai-text-hover">
                    Let's Talk{" "}
                    <img
                      className="ms-4"
                      src="/images/AboutUs/icons/arrow-right.svg"
                      alt=""
                    />
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
